export enum AugloopKeys {
    SessionUrl = "SessionUrl",
    SessionGuid = "SessionGuid",
    ServiceUrl = "ServiceUrl",
    InitializeAugloopRuntimeManagerDuration = "InitializeAugloopRuntimeManagerDuration",
    OnSessionConnect = "OnSessionConnect",
    OnSessionDisconnect = "OnSessionDisconnect",
    OnSessionDisconnectError = "OnSeessionDisconnectError",
    OnSessionClose = "OnSessionClose",
    OnSessionCloseReconnectAllowed = "OnSessionCloseReconnectAllowed",
    OnSessionCloseReason = "OnSessionCloseReason",
    SessionConnectAttempt = "OnSessionConnectAttempt"
};